import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from "@angular/core";
import {
  AbstractControl,
  ControlValueAccessor, FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from "@angular/forms";
import {Subject} from "rxjs";
import {KeyCode} from "../../utils/key-code";
import {debounceTime, map} from "rxjs/operators";
import {NgClass, NgIf, NgStyle} from "@angular/common";
import {LoadingCircularSpinnerComponent} from "../loading-circular-spinner/loading-circular-spinner.component";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-search-input',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './ds-search-input.component.html',
    styleUrls: ['./ds-search-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DsSearchInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DsSearchInputComponent),
            multi: true,
        }
    ],
    imports: [
        NgClass,
        LoadingCircularSpinnerComponent,
        NgStyle,
        FormsModule,
        NgIf
    ]
})
export class DsSearchInputComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor, Validator {

  @Input() value: string;
  @Input() width?: string;
  @Input() placeholder = '';
  @Input() hasSearchIcon = false;
  @Input() showLoading: boolean = false ;


  public onChange = new Subject<Event>();
  private _propagateChange: Function = (_: any) => {};


  constructor() {}

  public modelChange(str: string): void {
    this.value = str;
  }

  ngOnInit() {
    this.onChange
      .pipe(map((event: Event) => event.target['value']),
      debounceTime(200))
      .subscribe((value) => {
        this.value = value;
        this._propagateChange(value);
      });
  }

  ngOnDestroy() {
    this.onChange.unsubscribe();
    this.onChange = null;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.value = changes['value'].currentValue || '';
    }

    if (changes['placeholder']) {
      this.placeholder = changes['placeholder'].currentValue || '';
    }
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this._propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  validate(c: AbstractControl): ValidationErrors {
    return null;
  }

  registerOnValidatorChange(fn: () => void): void {}

  setDisabledState(isDisabled: boolean): void {}

  public onKeydown($event: any): void {
    if ($event.keyCode === KeyCode.ESCAPE && this.value !== '') {
      this.value = '';
      this._propagateChange('');
    }
  }

  public clearValue(): void {
    this.value = '';
    this._propagateChange('');
  }

}
